<i
  class="ene-icon action-icon-column"
  *ngIf="row[columnConfig.id]?.icon"
  [ngClass]="[row[columnConfig.id]?.icon, columnConfig.id]"
  [matTooltipDisabled]="!columnConfig.tooltip"
  [matTooltipClass]="columnConfig.id + '-tooltip'"
  [matTooltip]="row[columnConfig.id]?.tooltip"
  (click)="onTableAction({ id: columnConfig.id, type: 'click', row: row, index: index })"
></i>
